var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessTxn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.481 0H8.53333C3.08622 0 0 3.08622 0 8.53333V23.4667C0 28.9138 3.08622 32 8.53333 32H23.481C28.928 32 32 28.9138 32 23.4667V8.53333C32 3.08622 28.928 0 23.481 0Z",
    fill: "#00D220"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C14.12 8 12.38 8.66 11 9.76C9.16 11.22 8 13.48 8 16C8 17.5 8.42 18.92 9.16 20.12C10.54 22.44 13.08 24 16 24C18.02 24 19.86 23.26 21.26 22C21.88 21.48 22.42 20.84 22.84 20.12C23.58 18.92 24 17.5 24 16C24 11.58 20.42 8 16 8ZM20.14 15.14L15.88 19.08C15.6 19.34 15.22 19.48 14.86 19.48C14.48 19.48 14.1 19.34 13.8 19.04L11.82 17.06C11.24 16.48 11.24 15.52 11.82 14.94C12.4 14.36 13.36 14.36 13.94 14.94L14.9 15.9L18.1 12.94C18.7 12.38 19.66 12.42 20.22 13.02C20.78 13.62 20.74 14.58 20.14 15.14Z",
    fill: "#00D220"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTxn);
export default __webpack_public_path__ + "static/media/success-txn.473889f84c723a16bef861e7b6e35de7.svg";
export { ForwardRef as ReactComponent };